import React from "react"
import SearchProvider from "@/lib/redux-search/search-provider"
import useSearch from "@/lib/redux-search/use-search"
import { useVisit } from "@/lib/page-rendering"

function LegacySearchProvider({
  children,
  source,
  url,
}: {
  children: React.ReactNode
  source: string[]
  url: string
}) {
  const searchMethods = useSearch({ url, source })
  // Every visit searches again, as the page's props are the search's input.
  const { props } = useVisit()

  React.useEffect(() => {
    searchMethods.search()
  }, [props, searchMethods])

  return <SearchProvider {...searchMethods}>{children}</SearchProvider>
}

export { LegacySearchProvider as SearchProvider }
